import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

const fmtQty = (n) => (n == null ? "0" : Number(n).toLocaleString("cs-CZ", { maximumFractionDigits: 3 }));

// Vratka na sklad (§7) — vrátí nespotřebovaný materiál z výdejky zpět na sklad.
export function ReturnDialog({ mov, busy, onSubmit, onClose }) {
  const [qty, setQty] = useState(mov.returnable);
  const [note, setNote] = useState("");
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const over = Number(qty) > (mov.returnable || 0);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] overflow-y-auto" data-testid="return-dialog">
        <DialogHeader><DialogTitle>Vratka — {mov.name}</DialogTitle></DialogHeader>
        <div className="space-y-3.5">
          <p className="text-sm text-muted-foreground">Lze vrátit {fmtQty(mov.returnable)} {mov.unit}.</p>
          <div>
            <Label>Množství * ({mov.unit})</Label>
            <Input type="number" step="0.001" value={qty} onChange={(e) => setQty(e.target.value)} className="h-11 mt-1 w-full min-w-0" data-testid="return-qty" />
            {over && <p className="text-xs text-destructive mt-1">Lze vrátit nejvýše {fmtQty(mov.returnable)} {mov.unit}.</p>}
          </div>
          <div>
            <Label>Datum spotřeby</Label>
            <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="h-10 mt-1 w-full min-w-0" data-testid="return-date" />
            <p className="text-xs text-muted-foreground mt-1">Den, kdy se materiál na stavbě spotřeboval — objeví se v deníku toho dne.</p>
          </div>
          <div>
            <Label>Poznámka</Label>
            <Input value={note} onChange={(e) => setNote(e.target.value)} className="h-11 mt-1 w-full min-w-0" data-testid="return-note" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" className="w-full md:w-auto" onClick={onClose}>Zrušit</Button>
          <Button className="w-full md:w-auto" onClick={() => onSubmit({ qty, note, date })} disabled={busy || over || !qty} data-testid="return-confirm">
            {busy ? "Ukládám…" : "Vrátit na sklad"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
